const recipe = state => state.recipe
const recipes = state => state.recipes

export default {
  recipe,
  recipes
}
